import { Component, Input } from '@angular/core';
import { AvatarInfoConfig, AvatarInfoData, AvatarInfoItem } from '../../../models/ui-avatar.model';
@Component({
    selector: 'ui-avatar-info',
    templateUrl: './ui-avatar-info.component.html',
    styleUrls: ['./ui-avatar-info.component.scss'],
    standalone: false
})
export class UiAvatarInfoComponent {
  @Input() item?: AvatarInfoItem;
  @Input() data?: AvatarInfoData;
  @Input() config?: AvatarInfoConfig;

  get viewItem(): AvatarInfoItem {
    if (this.data && this.config) {
      return {
        ...this.data,
        ...this.config,
      };
    }

    if (this.item) {
      return this.item;
    }

    throw new Error('ui-avatar-info requires either item or both data and config inputs');
  }
}
